<template>
  <div class="modal warning fade" :class="{'is-open': open}">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">列印拜訪聯繫函</h3>
        </div>
        <div class="modal-body">
          <div class="warning">
            <ul>
              <li>在名單專區/服務、權益/異動後實質接觸明細項目內，有【實質接觸保戶】，請選擇列印格式</li>
              <li>如有疑問，請洽總公司業務部業務企劃科，(02)27551399 #{{ this.$store.state.serviceLine }}</li>
            </ul>  
          </div>
          <div class="action text-right">
            <a @click="$emit('selectType', '1')" class="btn btn-primary">親送專函</a>
            <a @click="$emit('selectType', '2')" class="btn btn-primary">郵寄專函</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'ChangeNoticeType',
  computed: {
    ...mapGetters(['BaseUrl'])
  },
  data () {
    return {
      checkComfirm: false,
    }
  },
  watch: {
    open () {
      this.checkComfirm = false
    },
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    inputData: {
      type: [ Object , String ],
      default: () =>{
        return {}
      }
    },
  },
  methods:{

  }
}
</script>
